import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { InventariosDetailProps } from "./InventariosDetail.type"
import "./InventariosDetail.css"

const emptyValue = "-"

const InventariosDetail = ({ isOpen, onClose, data }: InventariosDetailProps): JSX.Element => {
    // la fecha del reporte ya llega formateada desde el endpoint, se muestra igual que en la tabla
    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="inventarios-detail">
            <div className="inv-detail__head">
                <p className="inv-detail__title">Existencia en inventario</p>
                <p className="inv-detail__subtitle">{data?.numero_articulo || emptyValue}</p>
            </div>
            <div className="inv-detail__body">
                <div className="inv-detail__description">
                    <DescriptionDetail
                        icon={"Inbox"}
                        label={"Último surtido"}
                        value={data?.fecha_movimiento || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"HashWhite"}
                        label={"Cantidad"}
                        value={
                            data?.cantidad_movimiento !== undefined && data?.cantidad_movimiento !== null
                                ? String(data.cantidad_movimiento)
                                : emptyValue
                        }
                    />
                    <DescriptionDetail
                        className={"inv-detail__value--full"}
                        icon={"FileListFill"}
                        label={"Nombre del artículo"}
                        value={data?.articulo || emptyValue}
                    />
                    <DescriptionDetail icon={"packageFill"} label={"Marca"} value={data?.marca || emptyValue} />
                    <DescriptionDetail icon={"Inbox"} label={"Unidad"} value={data?.unidad || emptyValue} />
                    <DescriptionDetail
                        icon={"FolderFill"}
                        label={"Almacén"}
                        value={data?.almacen || emptyValue}
                    />
                    <DescriptionDetail icon={"priceTag"} label={"Tipo"} value={data?.tipo || emptyValue} />
                    <DescriptionDetail
                        icon={"CoinsFill"}
                        label={"Costo"}
                        value={formatCurrencyToFixed(data?.costo_compra || 0)}
                    />
                    <DescriptionDetail
                        icon={"dollarCircle"}
                        label={"Precio"}
                        value={formatCurrencyToFixed(data?.precio_venta || 0)}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default InventariosDetail
